import type { ReactNode } from 'react'
import { Button } from './Button.js'
import { Dialog } from './Dialog.js'

export interface ConfirmDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  title: string
  description?: ReactNode
  confirmLabel?: string
  cancelLabel?: string
  tone?: 'danger' | 'primary'
  loading?: boolean
}

export function ConfirmDialog({
  open, onClose, onConfirm, title, description,
  confirmLabel = 'تأكيد', cancelLabel = 'إلغاء', tone = 'danger', loading,
}: ConfirmDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={title}
      size="sm"
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={loading}>
            {cancelLabel}
          </Button>
          <Button variant={tone} onClick={onConfirm} loading={loading}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      {typeof description === 'string' ? (
        <p className="text-sm leading-relaxed text-fg-muted">{description}</p>
      ) : (
        description
      )}
    </Dialog>
  )
}
